import { Box } from "@mui/material";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <Box
      component={Link}
      to="/register"
      sx={{
        width: "100%",
        height: { xs: "auto", md: "100vh" },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#ffffff",
        textDecoration: "none",
        cursor: "pointer",
        overflow: "hidden",
        px: { xs: 0, md: 0 },
        mx: { xs: 0, md: 0 },
      }}
    >
      {/* Mobile Image - Display on xs and sm screens */}
      <Box
        component="img"
        src="/assets/herobannermobile.jpg"
        alt="Yuva Changemakers - Youth Leaders"
        sx={{
          width: "100%",
          height: "auto",
          display: { xs: "block", md: "none" },
          px: 0,
          mx: 0,
        }}
      />

      {/* Desktop Image - Display on md screens and above */}
      <Box
        component="img"
        src="/assets/herobannersix.jpg"
        // src="/assets/banner.svg"
        alt="Yuva Changemakers - Youth Leaders"
        sx={{
          width: "100%",
          height: "100%",
          maxHeight: "100vh",
          maxWidth: "100vw",
          objectFit: "cover",
          objectPosition: "center",
          display: { xs: "none", md: "block" },
        }}
      />
    </Box>
  );
};

export default HeroSection;
